import React from 'react';
import LocationTemplate from './LocationTemplate';

const SwansboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Swansboro"
      stateName="North Carolina"
      countyName="Onslow"
      zipCodes={["28584"]}
      latitude={34.6885}
      longitude={-77.1194}
      population={3570}
      historicalFact="Founded in 1783, known as the 'Friendly City by the Sea' with well-preserved historic downtown."
      nearbyTowns={[
        "Emerald Isle, NC",
        "Cape Carteret, NC",
        "Cedar Point, NC",
        "Peletier, NC",
        "Maysville, NC",
        "Jacksonville, NC",
        "Richlands, NC",
        "Morehead City, NC"
      ]}
    />
  );
};

export default SwansboroPage;